export default {"src":"/_next/static/media/facebook.42331537.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};